<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';
$color: var(--color-text);
$bg-color: var(--color-background-dark);

.toggler {
  --angle: 0deg;

  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: -10px;
  fill: $color;
  background: var(--color-card);
  border: 1px solid $bg-color;
  border-radius: 6px;
  z-index: 1000;
  transition: all 0.3s;
  transform: rotate(var(--angle));

  &:hover {
    background: $bg-color;
    border-color: $color;
  }

  @media screen and (max-width: variables.$xs) {
    display: none;
  }
}

.toggler[direction='top'] {
  --angle: 90deg;
}

.toggler[direction='right'] {
  --angle: 180deg;
}

.toggler[direction='bottom'] {
  --angle: -90deg;
}

.toggle {
  border-color: $color;
}
</style>

<template>
  <button
    class="toggler"
    :title="title"
    :class="{'toggle': isCollapsed}"
    :direction="direction"
    @click="onClick()"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 12 12"
    >
      <path d="M8.53 2.53a.75.75 0 00-1.06-1.06l1.06 1.06zM4 6l-.53-.53c-.3.3-.3.77 0 1.06L4 6zm3.47 4.53a.75.75 0 101.06-1.06l-1.06 1.06zm0-9.06l-4 4 1.06 1.06 4-4-1.06-1.06zm-4 5.06l4 4 1.06-1.06-4-4-1.06 1.06z" />
    </svg>
  </button>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    targetId: String,
    parentObject: {
      type: Object,
      default: function () {
        return {
          id: '',
          styleProp: '',
          defaultValue: 'unset'
        }
      }
    },
    shortcutName: {
      type: String,
      default: ''
    },
    direction: {
      validator: function (direction) {
        return (
          ['top', 'bottom', 'right'].find(value => value === direction) ||
          'left'
        )
      }
    }
  },
  computed: {
    title () {
      return (
        this.$text.tr(this.isCollapsed ? 'Развернуть' : 'Свернуть') +
        (this.shortcutName && ` (${this.shortcutName})`)
      )
    },
    isCollapsed: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    isCollapsed: function () {
      this.$nextTick(() => {
        this.toggle()
      })
    }
  },
  mounted () {
    if (this.value) {
      this.toggle()
    }
  },
  methods: {
    onClick () {
      this.isCollapsed = !this.isCollapsed
      this.$nextTick(() => {
        this.$emit('click')
      })
    },
    toggle () {
      if (this.targetId) {
        this.toggleTarget()
      }

      if (this.parentObject.id) {
        this.toggleParentStyle()
      }

      this.rotateArrowAngle()
    },
    toggleTarget () {
      const target = document.getElementById(this.targetId)

      if (this.isCollapsed) {
        target.style.display = 'none'
      } else {
        target.style.display = ''
      }
    },
    toggleParentStyle () {
      const main = document.getElementById(this.parentObject.id)

      if (this.isCollapsed) {
        main.style[this.parentObject.styleProp] =
          this.parentObject.defaultValue || 'unset'
      } else {
        main.style[this.parentObject.styleProp] = ''
      }
    },
    rotateArrowAngle () {
      let angle = parseInt(
        getComputedStyle(this.$el).getPropertyValue('--angle')
      )
      this.isCollapsed ? (angle += 180) : (angle -= 180)
      this.$el.style.setProperty('--angle', `${angle}deg`)
    }
  }
}
</script>
